export let openMapAddress = '';
if (window.location.hostname === 'lausd.map.clarity.io') {
  openMapAddress = 'https://lausd.map.clarity.io';
} else {
  openMapAddress = import.meta.env.VITE_OPENMAP_ADDRESS;
}
